import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import {
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from '@material-ui/core'
import { Modal } from '../../common/Modal'

export const CreatePermissionGroupModal = ({
    userRoles,
    setModalOpen,
    okMethod,
}) => {
    const [formState, setFormState] = useState({
        title: null,
        roleId: null,
        isEnabled: true,
    })

    const formStateSet = () => {
        return !Object.keys(formState).every(
            key => formState[key] !== null && formState[key] !== ''
        )
    }

    const createForm = () => {
        return (
            <Grid>
                <FormControl>
                    <TextField
                        required={true}
                        label={'Title'}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                title: val,
                            })
                        }}
                    />
                </FormControl>

                <FormControl>
                    <InputLabel required={true}>Role</InputLabel>
                    <Select
                        value={formState.roleId}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                roleId: val,
                            })
                        }}>
                        {userRoles.map(it => {
                            return <MenuItem value={it.id}>{it.value}</MenuItem>
                        })}
                    </Select>
                </FormControl>

                <FormControl>
                    <InputLabel required={true}>Is Enabled?</InputLabel>
                    <Select
                        value={formState.isEnabled}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                isEnabled: val,
                            })
                        }}>
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        )
    }

    return (
        <Modal
            data-testid='create-permission-group-modal'
            title='Add New Permission Group'
            cancelText='Close'
            okText='Add'
            okMethod={() => okMethod(formState)}
            openModal={setModalOpen}
            isOkDisabled={formStateSet()}
            maxWidth='md'
            fullWidth={true}>
            {createForm()}
        </Modal>
    )
}
